import React, { PropsWithChildren } from 'react'
import { Layout } from './Layout'
import { useProps } from './useProps'

export const MetamaskInstallCheckerProvider = ({ children }: PropsWithChildren) => {
  return <Layout {...useProps()}>{children}</Layout>
}
